"use strict";

import App from "./modules/App";

window.$ = window.jQuery;

jQuery(document).ready(function () {
    App.init();
});
